// @ts-ignore
export module CCRolesType {
  export enum Roles {
    ROLE_SYSTEM = 'ROLE_SYSTEM',
    ROLE_SCHEDULER_ADMIN = 'ROLE_SCHEDULER_ADMIN',
    ROLE_TOOLS_ADMIN = 'ROLE_TOOLS_ADMIN',
    ROLE_SECURITY = 'ROLE_SECURITY',
    ROLE_SECURITY_TEAM = 'ROLE_SECURITY_TEAM',
    ROLE_SUPERVISOR = 'ROLE_SUPERVISOR',
    ROLE_CLEARER = 'ROLE_CLEARER',
    ROLE_CLEARER_TRADE_PRICE_UPDATE = 'ROLE_CLEARER_TRADE_PRICE_UPDATE',
    ROLE_CLEARER_FLEX = 'ROLE_CLEARER_FLEX',
    ROLE_CLEARER_TRADER_MEMO_UPDATE = 'ROLE_CLEARER_TRADER_MEMO_UPDATE',
    ROLE_CLEARER_ORDER_PRECREATE = 'ROLE_CLEARER_ORDER_PRECREATE',
    ROLE_CLEARER_POF = 'ROLE_CLEARER_POF',
    ROLE_ADVANCED_CLEARER = 'ROLE_ADVANCED_CLEARER',
    ROLE_STATIC_MANAGER = 'ROLE_STATIC_MANAGER',
    ROLE_STATIC_MANAGER_TRADER = 'ROLE_STATIC_MANAGER_TRADER',
    ROLE_TRADER = 'ROLE_TRADER',
    ROLE_HEAD_OF_TRADER = 'ROLE_HEAD_OF_TRADER',
    ROLE_CUSTOMER = 'ROLE_CUSTOMER',
    ROLE_ADVANCED_CUSTOMER = 'ROLE_ADVANCED_CUSTOMER',
    ROLE_EXCHANGE = 'ROLE_EXCHANGE',
    ROLE_ADVANCED_EXCHANGE = 'ROLE_ADVANCED_EXCHANGE',
    ROLE_MAPPING = 'ROLE_MAPPING',
    ROLE_ADVANCED_MAPPING = 'ROLE_ADVANCED_MAPPING',
    ROLE_GUEST = 'ROLE_GUEST',
    ROLE_ARCHIVE_REPORT_FORM = 'ROLE_ARCHIVE_REPORT_FORM',
    ROLE_ARCHIVE_RECAP_FORM = 'ROLE_ARCHIVE_RECAP_FORM',
    ROLE_ARCHIVE_RECAP_LIST = 'ROLE_ARCHIVE_RECAP_LIST',
    ROLE_ARCHIVE_REPORT_PROFILES = 'ROLE_ARCHIVE_REPORT_PROFILES',
    ROLE_ARCHIVE_REPORT_PROFILES_GROUP_LIMITED = 'ROLE_ARCHIVE_REPORT_PROFILES_GROUP_LIMITED',
    ROLE_ARCHIVE_REPORT_PROFILES_GROUP_ADMIN = 'ROLE_ARCHIVE_REPORT_PROFILES_GROUP_ADMIN',
    ROLE_ARCHIVE_REPORT_PROFILES_SCHEDULE_ADMIN = 'ROLE_ARCHIVE_REPORT_PROFILES_SCHEDULE_ADMIN',
    ROLE_ARCHIVE_REPORT_TEMPLATES = 'ROLE_ARCHIVE_REPORT_TEMPLATES',
    ROLE_ARCHIVE_REPORT_TEMPLATES_GROUP_LIMITED = 'ROLE_ARCHIVE_REPORT_TEMPLATES_GROUP_LIMITED',
    ROLE_ARCHIVE_RECAP_PROFILES = 'ROLE_ARCHIVE_RECAP_PROFILES',
    ROLE_ARCHIVE_RECAP_PROFILES_GROUP_LIMITED = 'ROLE_ARCHIVE_RECAP_PROFILES_GROUP_LIMITED',
    ROLE_ARCHIVE_RECAP_PROFILES_GROUP_ADMIN = 'ROLE_ARCHIVE_RECAP_PROFILES_GROUP_ADMIN',
    ROLE_ARCHIVE_RECAP_PROFILES_SCHEDULE_ADMIN = 'ROLE_ARCHIVE_RECAP_PROFILES_SCHEDULE_ADMIN',
    ROLE_ARCHIVE_RECAP_TEMPLATES = 'ROLE_ARCHIVE_RECAP_TEMPLATES',
    ROLE_ARCHIVE_RECAP_TEMPLATES_GROUP_LIMITED = 'ROLE_ARCHIVE_RECAP_TEMPLATES_GROUP_LIMITED',
    ROLE_TOTAL_RESIDUAL_ADJUSTMENT = 'ROLE_TOTAL_RESIDUAL_ADJUSTMENT',
    ROLE_TRADEORDER_VIEW = 'ROLE_TRADEORDER_VIEW',
    ROLE_TRADEORDER_VIEW_MANAGER = 'ROLE_TRADEORDER_VIEW_MANAGER',
    ROLE_TRADEORDER_VIEW_MANAGER_TEAM = 'ROLE_TRADEORDER_VIEW_MANAGER_TEAM',
    ROLE_ETICKET_ADD = 'ROLE_ETICKET_ADD',
    ROLE_ETICKETS_MANAGE = 'ROLE_ETICKETS_MANAGE',
    ROLE_BILLING = 'ROLE_BILLING',
    ROLE_DATA_AMENDMENT_ORDER = 'ROLE_DATA_AMENDMENT_ORDER',
    ROLE_DATA_AMENDMENT_TRADE = 'ROLE_DATA_AMENDMENT_TRADE',
    ROLE_DATA_AMENDMENT_CLEARING = 'ROLE_DATA_AMENDMENT_CLEARING',
  }
}

export class CCRoles {
  static ROLES_NEW_ETICKET: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ETICKET_ADD];
  static ROLES_LIST_ETICKET: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ETICKETS_MANAGE];

  static ROLES_AMEND_ORDER: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_DATA_AMENDMENT_ORDER];
  static ROLES_AMEND_TRADE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_DATA_AMENDMENT_TRADE];
  static ROLES_AMEND_CLEARING: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_DATA_AMENDMENT_CLEARING];

  static ROLES_CLEARING_TRADE_PRICE_UPDATE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_CLEARER_TRADE_PRICE_UPDATE];
  static ROLES_CLEARING_TRADER_MEMO_UPDATE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_CLEARER_TRADER_MEMO_UPDATE];
  static ROLES_CLEARER_ORDER_PRECREATE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_CLEARER_ORDER_PRECREATE];
  static ROLES_CLEARING_FLEX_REQUEST: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_CLEARER_FLEX];
  static ROLES_CLEARING_READONLY: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_GUEST];
  static ROLES_CLEARING: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ADVANCED_CLEARER,
    CCRolesType.Roles.ROLE_CLEARER, CCRolesType.Roles.ROLE_GUEST, CCRolesType.Roles.ROLE_TRADER, CCRolesType.Roles.ROLE_HEAD_OF_TRADER];
  static ROLES_CLEARING_ADMIN: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ADVANCED_CLEARER,
    CCRolesType.Roles.ROLE_CLEARER, CCRolesType.Roles.ROLE_TRADER, CCRolesType.Roles.ROLE_HEAD_OF_TRADER];
  static ROLES_CLEARING_POF: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_CLEARER_POF];

  static ROLES_ARCHIVE_FORM: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ARCHIVE_REPORT_FORM];
  static ROLES_RECAP_FORM: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_FORM];
  static ROLES_RECAP_LIST: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_LIST];
  static ROLES_ARCHIVE_ADMIN: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM];
  static ROLES_ARCHIVE_RECAP_PROFILE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES
    , CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES_GROUP_ADMIN, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES_SCHEDULE_ADMIN];
  static ROLES_ARCHIVE_EXPORT_PROFILE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES
    , CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES_GROUP_ADMIN, CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES_SCHEDULE_ADMIN];
  static ROLES_ARCHIVE_REPORT_TASKS: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES, CCRolesType.Roles.ROLE_ARCHIVE_REPORT_FORM];
  static ROLES_ARCHIVE_RECAP_TASKS: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_FORM, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_LIST];

  static ROLES_BILLING_LIST: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_BILLING];

  static ROLES_ARCHIVE_TOTAL_RESIDUAL_ADJUST: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_TOTAL_RESIDUAL_ADJUSTMENT];

  static ROLES_TOOLS: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,CCRolesType.Roles.ROLE_SCHEDULER_ADMIN,CCRolesType.Roles.ROLE_TOOLS_ADMIN
    , CCRolesType.Roles.ROLE_SECURITY, CCRolesType.Roles.ROLE_SECURITY_TEAM];
  static ROLES_TOOLS_SCHEDULER: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,CCRolesType.Roles.ROLE_SCHEDULER_ADMIN];
  static ROLES_TOOLS_ADMIN: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,CCRolesType.Roles.ROLE_TOOLS_ADMIN];
  static ROLES_TOOLS_SUPPORT_TOC: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,CCRolesType.Roles.ROLE_TOOLS_ADMIN];

  static ROLES_CONFIG: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,
    CCRolesType.Roles.ROLE_ADVANCED_CUSTOMER, CCRolesType.Roles.ROLE_CUSTOMER, CCRolesType.Roles.ROLE_SECURITY,
    CCRolesType.Roles.ROLE_GUEST, CCRolesType.Roles.ROLE_CLEARER, CCRolesType.Roles.ROLE_TRADER];

  static ROLES_CUSTOMER_READ: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,
    CCRolesType.Roles.ROLE_ADVANCED_CUSTOMER, CCRolesType.Roles.ROLE_CUSTOMER];
  static ROLES_CUSTOMER_TRADER_READ: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,
    CCRolesType.Roles.ROLE_ADVANCED_CUSTOMER, CCRolesType.Roles.ROLE_CUSTOMER];
  static ROLES_CUSTOMER_READ_ADVANCED: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,
    CCRolesType.Roles.ROLE_ADVANCED_CUSTOMER];

  static ROLES_CUSTOMER_WRITE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_STATIC_MANAGER];
  static ROLES_CUSTOMER_WRITE_TRADER: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_STATIC_MANAGER_TRADER];

  static ROLES_EXCHANGE_READ: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,
    CCRolesType.Roles.ROLE_ADVANCED_EXCHANGE, CCRolesType.Roles.ROLE_EXCHANGE];
  static ROLES_EXCHANGE_READ_ADVANCED: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,
    CCRolesType.Roles.ROLE_ADVANCED_EXCHANGE];
  static ROLES_EXCHANGE_WRITE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_STATIC_MANAGER];

  static ROLES_MAPPING_READ: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,
    CCRolesType.Roles.ROLE_ADVANCED_MAPPING, CCRolesType.Roles.ROLE_MAPPING];
  static ROLES_MAPPING_READ_ADVANCED: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,
    CCRolesType.Roles.ROLE_ADVANCED_MAPPING];
  static ROLES_MAPPING_WRITE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_STATIC_MANAGER];

  static ROLES_SECURITY: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_SECURITY, CCRolesType.Roles.ROLE_SECURITY_TEAM];
  static ROLES_SECURITY_DELETE: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_SECURITY];
  static ROLES_INTERNAL: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_GUEST,
    CCRolesType.Roles.ROLE_CLEARER, CCRolesType.Roles.ROLE_TRADER];

  static ROLES_INTERNAL_TRADEORDER_VIEW: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_TRADEORDER_VIEW_MANAGER, CCRolesType.Roles.ROLE_TRADEORDER_VIEW_MANAGER_TEAM,
    CCRolesType.Roles.ROLE_TRADEORDER_VIEW];
  static ROLES_INTERNAL_TRADEORDER_VIEW_ADMIN: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_TRADEORDER_VIEW_MANAGER, CCRolesType.Roles.ROLE_TRADEORDER_VIEW_MANAGER_TEAM];

  static ROLES_ALL: CCRolesType.Roles[] = [CCRolesType.Roles.ROLE_SYSTEM,CCRolesType.Roles.ROLE_SCHEDULER_ADMIN,CCRolesType.Roles.ROLE_TOOLS_ADMIN,
    CCRolesType.Roles.ROLE_SECURITY, CCRolesType.Roles.ROLE_SECURITY_TEAM, CCRolesType.Roles.ROLE_SUPERVISOR,
    CCRolesType.Roles.ROLE_CLEARER, CCRolesType.Roles.ROLE_ADVANCED_CLEARER,
    CCRolesType.Roles.ROLE_STATIC_MANAGER, CCRolesType.Roles.ROLE_STATIC_MANAGER_TRADER,
    CCRolesType.Roles.ROLE_TRADER, CCRolesType.Roles.ROLE_HEAD_OF_TRADER,
    CCRolesType.Roles.ROLE_CUSTOMER, CCRolesType.Roles.ROLE_ADVANCED_CUSTOMER,
    CCRolesType.Roles.ROLE_TRADEORDER_VIEW_MANAGER, CCRolesType.Roles.ROLE_TRADEORDER_VIEW_MANAGER_TEAM, CCRolesType.Roles.ROLE_TRADEORDER_VIEW,
    CCRolesType.Roles.ROLE_GUEST, CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES, CCRolesType.Roles.ROLE_ARCHIVE_REPORT_TEMPLATES,CCRolesType.Roles.ROLE_ARCHIVE_REPORT_TEMPLATES_GROUP_LIMITED,
    CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_TEMPLATES,CCRolesType.Roles.ROLE_ARCHIVE_RECAP_TEMPLATES_GROUP_LIMITED,
    CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES_GROUP_ADMIN, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES_GROUP_ADMIN,
    CCRolesType.Roles.ROLE_ARCHIVE_REPORT_PROFILES_SCHEDULE_ADMIN, CCRolesType.Roles.ROLE_ARCHIVE_RECAP_PROFILES_SCHEDULE_ADMIN];
}
